import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import news from "./Post.module.css";
import Nav from "../Navbar/Nav";
import Footer from "../Footer/Footer";
import ImgII from "../../img/1mg18.png";
import { fetchPostById } from "../../Api/PostManApi";

const PostD = () => {
  const { id } = useParams(); // Get ID from URL
  console.log("🔹 Extracted ID from URL:", id);

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getPost = async () => {
      setLoading(true);
      const data = await fetchPostById(id);
      setPost(data);
      setLoading(false);
    };

    getPost();
  }, [id]);

  return (
    <div>
      <Nav />
      <div className={news.news}>
        <div className={news.container}>
          <h1>News</h1>
          {loading ? (
            <p>Loading...</p>
          ) : post ? (
            <div className={news.flex}>
              <div className={news.imgI}>
                <img src={ImgII} alt="" />
              </div>
              <h1>{post.title}</h1>
              <p>{post.description}</p>
              <p>{post.author.name}</p>
              <p>{post.author.email}</p>
            </div>
          ) : (
            <p>❌ Post not found.</p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PostD;
